import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom'; // Hook para navegação
import Sidebar from '../../components/Sidebar/Sidebar';
import { Button, Modal, Box, TextField, MenuItem } from '@mui/material';
import './Processos.css';

const apiUrl = process.env.REACT_APP_API_URL;

function Processos() {
  const [processos, setProcessos] = useState([]);
  const [filteredProcessos, setFilteredProcessos] = useState([]); // Para os dados filtrados
  const [filters, setFilters] = useState({
    name: '',
    tipo_id: '',
    e2e_id: '',
    gestor_id: '',
  });
  const [openModal, setOpenModal] = useState(false);
  const [editingProcesso, setEditingProcesso] = useState(null);
  const [formValues, setFormValues] = useState({
    name: '',
    tipo_id: '',
    e2e_id: '',
    gestor_id: '',
    metrica_sla: '',
    produtividade_meta: '',
    carga_horaria: '',
  });
  const [tipos, setTipos] = useState([]);
  const [e2es, setE2es] = useState([]);
  const [gestores, setGestores] = useState([]);

  const [isSidebarOpen, setSidebarOpen] = useState(true);

  const navigate = useNavigate(); // Hook para navegação

  // Fetch dados iniciais
  useEffect(() => {
    axios
      .get(`${apiUrl}/servicos`)
      .then((response) => {
        setProcessos(response.data);
        setFilteredProcessos(response.data); // Inicialmente, todos os dados
      })
      .catch((error) => console.error('Erro ao buscar processos:', error));

    axios
      .get(`${apiUrl}/tipos-servicos`)
      .then((response) => setTipos(response.data))
      .catch((error) => console.error('Erro ao buscar tipos:', error));

    axios
      .get(`${apiUrl}/e2e`)
      .then((response) => setE2es(response.data))
      .catch((error) => console.error('Erro ao buscar E2E:', error));

    axios
      .get(`${apiUrl}/gestores`)
      .then((response) => setGestores(response.data))
      .catch((error) => console.error('Erro ao buscar gestores:', error));
  }, []);

  // Filtrando os processos com base nos filtros
  const handleFilterChange = (key, value) => {
    const newFilters = { ...filters, [key]: value };
    setFilters(newFilters);

    const filtered = processos.filter((processo) => {
      return (
        (!newFilters.name || processo.name.includes(newFilters.name)) &&
        (!newFilters.tipo_id || processo.tipo_id === parseInt(newFilters.tipo_id)) &&
        (!newFilters.e2e_id || processo.e2e_id === parseInt(newFilters.e2e_id)) &&
        (!newFilters.gestor_id || processo.gestor_id === parseInt(newFilters.gestor_id))
      );
    });

    setFilteredProcessos(filtered);
  };

  // Abre o modal
  const handleOpenModal = (processo = null) => {
    setEditingProcesso(processo);
    setFormValues(
      processo
        ? { ...processo }
        : {
            name: '',
            tipo_id: '',
            e2e_id: '',
            gestor_id: '',
            metrica_sla: '',
            produtividade_meta: '',
            carga_horaria: '',
          }
    );
    setOpenModal(true);
  };

  // Fecha o modal
  const handleCloseModal = () => {
    setOpenModal(false);
    setEditingProcesso(null);
  };

  // Salvar/Editar Processo
  const handleSave = () => {
    const username = localStorage.getItem('username'); // Recupera o username do localStorage

    const payload = {
      ...formValues,
      produtividade_meta: parseFloat(formValues.produtividade_meta),
      carga_horaria: parseFloat(formValues.carga_horaria),
      tipo_id: parseInt(formValues.tipo_id),
      e2e_id: parseInt(formValues.e2e_id),
      gestor_id: parseInt(formValues.gestor_id),
      creator_id: username, // Adiciona o username como creator_id
    };

    const endpoint = editingProcesso
      ? `${apiUrl}/servicos/${editingProcesso.id}`
      : `${apiUrl}/servicos`;
    const method = editingProcesso ? 'put' : 'post';

    axios[method](endpoint, payload)
      .then((response) => {
        if (editingProcesso) {
          setProcessos((prev) =>
            prev.map((item) => (item.id === response.data.id ? response.data : item))
          );
        } else {
          setProcessos((prev) => [...prev, response.data]);
        }
        handleCloseModal();
      })
      .catch((error) => console.error('Erro ao salvar processo:', error));
  };

  // Deletar Processo
  const handleDelete = (id) => {
    if (window.confirm('Tem certeza que deseja excluir?')) {
      axios
        .delete(`${apiUrl}/servicos/${id}`)
        .then(() => setProcessos((prev) => prev.filter((item) => item.id !== id)))
        .catch((error) => console.error('Erro ao deletar processo:', error));
    }
  };

  // Navegar para a página de detalhes
  const handleRowClick = (processo) => {
    navigate(`/processos/${processo.id}`, { state: { processo } }); // Passa o processo pelo state
  };

  return (
    <div className="processos-container">
      <Sidebar isOpen={isSidebarOpen} toggleSidebar={() => setSidebarOpen(!isSidebarOpen)} />
      <div className={`content ${isSidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
        <div className="header">
          <h2>Processos</h2>
          <Button variant="contained" className="custom-add-button" onClick={() => handleOpenModal()}>
            + Adicionar
          </Button>
        </div>

        {/* Filtros */}
        <div className="filters">
          <TextField
            label="Serviço"
            variant="outlined"
            size="small"
            value={filters.name}
            onChange={(e) => handleFilterChange('name', e.target.value)}
          />
          <TextField
            label="Tipo"
            variant="outlined"
            size="small"
            select
            value={filters.tipo_id}
            onChange={(e) => handleFilterChange('tipo_id', e.target.value)}
          >
            <MenuItem value="">Todos</MenuItem>
            {tipos.map((tipo) => (
              <MenuItem key={tipo.id} value={tipo.id}>
                {tipo.tipo_name}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            label="E2E"
            variant="outlined"
            size="small"
            select
            value={filters.e2e_id}
            onChange={(e) => handleFilterChange('e2e_id', e.target.value)}
          >
            <MenuItem value="">Todos</MenuItem>
            {e2es.map((e2e) => (
              <MenuItem key={e2e.id} value={e2e.id}>
                {e2e.e2e_name}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            label="Gestor"
            variant="outlined"
            size="small"
            select
            value={filters.gestor_id}
            onChange={(e) => handleFilterChange('gestor_id', e.target.value)}
          >
            <MenuItem value="">Todos</MenuItem>
            {gestores.map((gestor) => (
              <MenuItem key={gestor.id} value={gestor.id}>
                {gestor.name}
              </MenuItem>
            ))}
          </TextField>
        </div>

        <table className="custom-table">
          <thead>
            <tr>
              <th>Serviço</th>
              <th>Tipo</th>
              <th>E2E</th>
              <th>Gestor</th>
              <th>Métrica SLA</th>
              <th>Produtividade</th>
              <th>Carga Horária</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {filteredProcessos.map((processo) => (
              <tr key={processo.id} className="clickable-row" onClick={() => handleRowClick(processo)}>
                <td>{processo.name}</td>
                <td>{tipos.find((tipo) => tipo.id === processo.tipo_id)?.tipo_name}</td>
                <td>{e2es.find((e2e) => e2e.id === processo.e2e_id)?.e2e_name}</td>
                <td>{gestores.find((gestor) => gestor.id === processo.gestor_id)?.name}</td>
                <td>{processo.metrica_sla}</td>
                <td>{processo.produtividade_meta}</td>
                <td>{processo.carga_horaria}</td>
                <td
                  onClick={(e) => e.stopPropagation()} // Impede a propagação do clique para a linha
                >
                  <Button
                    variant="text"
                    className="custom-edit-button"
                    onClick={() => handleOpenModal(processo)}
                  >
                    Editar
                  </Button>
                  <Button
                    variant="text"
                    className="custom-delete-button"
                    onClick={() => handleDelete(processo.id)}
                  >
                    Excluir
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Modal */}
        <Modal open={openModal} onClose={handleCloseModal}>
          <Box className="modal-box">
            <h2>{editingProcesso ? 'Editar Processo' : 'Adicionar Novo Processo'}</h2>
            <div className="modal-grid">
              <TextField
                label="Nome"
                variant="outlined"
                className="full-width"
                value={formValues.name}
                onChange={(e) => setFormValues({ ...formValues, name: e.target.value })}
                margin="normal"
              />
              <TextField
                label="Tipo"
                variant="outlined"
                select
                value={formValues.tipo_id}
                onChange={(e) => setFormValues({ ...formValues, tipo_id: e.target.value })}
                margin="normal"
              >
                {tipos.map((tipo) => (
                  <MenuItem key={tipo.id} value={tipo.id}>
                    {tipo.tipo_name}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                label="E2E"
                variant="outlined"
                select
                value={formValues.e2e_id}
                onChange={(e) => setFormValues({ ...formValues, e2e_id: e.target.value })}
                margin="normal"
              >
                {e2es.map((e2e) => (
                  <MenuItem key={e2e.id} value={e2e.id}>
                    {e2e.e2e_name}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                label="Gestor"
                variant="outlined"
                select
                value={formValues.gestor_id}
                onChange={(e) => setFormValues({ ...formValues, gestor_id: e.target.value })}
                margin="normal"
              >
                {gestores.map((gestor) => (
                  <MenuItem key={gestor.id} value={gestor.id}>
                    {gestor.name}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                label="Métrica SLA"
                variant="outlined"
                select
                value={formValues.metrica_sla}
                onChange={(e) => setFormValues({ ...formValues, metrica_sla: e.target.value })}
                margin="normal"
              >
                <MenuItem value="Horas">Horas</MenuItem>
                <MenuItem value="Dias">Dias</MenuItem>
              </TextField>
              <TextField
                label="Produtividade (Meta de Serviços)"
                variant="outlined"
                type="number"
                value={formValues.produtividade_meta}
                onChange={(e) => setFormValues({ ...formValues, produtividade_meta: e.target.value })}
                margin="normal"
              />
              <TextField
                label="Carga Horária de Trabalho"
                variant="outlined"
                type="number"
                value={formValues.carga_horaria}
                onChange={(e) => setFormValues({ ...formValues, carga_horaria: e.target.value })}
                margin="normal"
              />
            </div>
            <div className="modal-actions">
              <Button className="custom-save-button" onClick={handleSave}>
                Salvar
              </Button>
              <Button className="custom-cancel-button" onClick={handleCloseModal}>
                Cancelar
              </Button>
            </div>
          </Box>
        </Modal>
      </div>
    </div>
  );
}

export default Processos;
